import type { Release } from '../releases.ts';

export default {
  version: '0.11.0',
  date: '2026-10-02',
  title: 'Storage policies',
  summary: [
    'Storage quotas: a hard limit per location, with a warning from 90%',
    'Tiering rules copy, move or delete files between locations after a number of days',
    'Rules can apply to one asset class or media type, with Dry run and Run now',
  ],
  features: [
    'Storage quotas: a hard limit per location on what PRISM keeps there, shown as its capacity, with a warning from 90% in Storage and System status',
    'Tiering rules: copy, move or delete originals, proxies or renditions between locations a number of days after ingest (or after arriving), optionally only for an asset class or media type; dry run and Run now',
  ],
  fixes: [],
} satisfies Release;
